export class PriceStore {
    private numberSimultaneousConnections: Record<number, number>;
    private solutionIndex: number;
    constructor() {
        this.numberSimultaneousConnections = {0: 0};
        this.solutionIndex = 0;
    }
    setIndexSliderConnections(index: number, numberSimultaneousConnections: number): void {
        this.numberSimultaneousConnections[index] = numberSimultaneousConnections;
    }
    getIndexSliderConnections(): Record<number, number> {
        return this.numberSimultaneousConnections
    }
    setSolutionIndex(index: number): void {
        this.solutionIndex = index;
    }
    gerSolutionIndex(): number {
        return this.solutionIndex
    }
}
